import request from '@/utils/request'

export function login(data) {
  return request({ url: '/auth/login', method: 'post', data })
}

export function getCaptcha() {
  return request({ url: '/auth/captcha', method: 'get' })
}

export function getProfile() {
  return request({ url: '/users/me', method: 'get' })
}

